<template>
  <v-app id="ui" fluid app tag="section">
    <v-row justify="center" class="centerTop">
      <v-col cols="5">
        <base-material-card
          :color="isViewer ? 'green' : 'blue'"
          title="Log In"
          class="px-5 py-3"
          icon="mdi-login"
          id="white"
        >
          <Notification></Notification>
          <v-card-text class="px-0 pb-0">
            <v-sheet>
              <v-form ref="login">
                <v-text-field
                  v-model="username"
                  label="Username"
                  class="purple-input"
                  :rules="requiredRules"
                  hide-details="auto"
                />
                <br />
                <v-text-field
                  v-model="password"
                  hint="password"
                  label="Password"
                  :rules="requiredRules"
                  hide-details="auto"
                  type="password"
                />
                <br />
                <v-row class="ma-0 pa-0">
                  <v-col>
                    <v-btn
                      :color="isViewer ? 'green' : 'blue'"
                      block
                      :loading="loader"
                      :disabled="loader"
                      @click="login"
                    >Log In</v-btn>
                  </v-col>
                  <v-col v-if="!isViewer">
                    <v-btn
                      type="button"
                      block
                      outlined
                      to="/forgot_password"
                      title="Forgot Password"
                    >Forgot Password</v-btn>
                  </v-col>
                </v-row>
              </v-form>

            </v-sheet>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>

    <template slot="default">
      <div id="bg" :style="bgStyle"></div>
      <div id="overlay"></div>
    </template>
  </v-app>
</template>

<script>
import moment from "moment";
import common from "../mixins/common";

export default {
  name: "Login",
  components: {
    Notification: () => import("../components/Notification")
  },
  mixins: [common],
  computed: {
    bgStyle() {
      const country = process.env.VUE_APP_COUNTRY; 
      const image = country === "KENYA"
        ? require("@/assets/bg.ntsa.jpg")
        : require("@/assets/bg.jpg");

      return {
        background: `url(${image}) no-repeat center center fixed`,
        backgroundSize: "cover", 
      };
    },
    isViewer() {
      return process.env.VUE_APP_SYSTEMROLE === "VIEWER";
    }
  }, 
  created() {
    localStorage.clear(); 
  },
  data() {
    return {
      username: "",
      password: ""
    };
  },
  methods: {
    login() { 
      localStorage.clear();
      if (this.$refs.login.validate()) {    
          var resp = this.http_connect("/login", {
            username: this.username,
            password: this.password, 
          }).then(rp => {    
            if (rp.status == 200) {
              if (rp.data.status.toLowerCase() == "fail") {
                this.setNotification("error", rp.data.payload);
              } else {    
                this.$store.dispatch("LOG_IN", {
                  token: rp.data.token,
                  refresh: rp.data.refresh_token,
                  menus: this.menus,
                  account: rp.data.account,
                  expiration: moment(rp.data.exp, "YYYYMMDDHHmmss"),

                });  
  

                if(this.username.toLowerCase()=="ntsa")
                    this.$router.push("/ntsa"); 
                else
                  this.$router.push("/account/dashboard"); 
              }
            } else this.setNotification("error", rp.data.payload);

          }); 
      }
    }, 
  }
};
</script>

<style>
#bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background: url("../../assets/bg.jpg") no-repeat center center fixed; */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

#overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
}

#white {
  background: #fff !important;
  z-index: 102020;
  min-width: 200px;
}

.centerTop {
  margin-top: 8% !important;
}
</style>
